import { SET_SEARCH_RESULTS } from "@/store/mutation-types";

export default {
  [SET_SEARCH_RESULTS](state, { results = null, type = "global" }) {
    state.results[type] = results;
  }
};
